/* eslint-disable no-undef */
/**
 * @module read-only/readonlycommand
 */

import { Command } from 'ckeditor5'
/**
 * @extends module:core/command~Command
 */
export default class ReadOnlyCommand extends Command {
    /**
     * @inheritDoc
     */
    refresh() {
        const model = this.editor.model;
        const doc = model.document;
        const element = doc.selection.getSelectedElement();

        // this.value = !!doc.selection.getAttribute( 'content' );
        // this.isEnabled = model.schema.checkAttributeInSelection( doc.selection, 'content' );
        this.value = element && element.name === 'readonly';
        this.isEnabled = model.schema.checkChild(doc.selection.focus.parent, 'readonly');
    }

    /**
     * @inheritDoc
     */
    execute(options = {}) {
        const model = this.editor.model;
        const document = model.document;
        const selection = document.selection;
        const valueToSet = (options.forceValue === undefined) ? !this.value : options.forceValue;

        model.change(writer => {
            // const ranges = model.schema.getValidRanges( selection.getRanges(), 'readonly' );
            const ranges = selection.getRanges();

            const range = selection.getFirstRange();
            let content = '';
            for (const item of range.getItems()) {
                content += item.data ? item.data : item.getAttribute('content');
            }

            if (selection.isCollapsed) {
                if (valueToSet) {
                    // writer.setSelectionAttribute( 'readonly', valueToSet );
                    writer.createElement('readonly', {
                        ...Object.fromEntries(selection.getAttributes()),
                        content
                    });
                } else {
                    const isSameReadOnly = value => value.item.getAttribute('readonly') === this.value;
                    const readonlyStart = selection.focus.getLastMatchingPosition(isSameReadOnly, {
                        direction: 'backward'
                    });
                    const readonlyEnd = selection.focus.getLastMatchingPosition(isSameReadOnly);
                    const focus = selection.focus;

                    writer.removeSelectionAttribute('readonly');

                    if (!(focus.isEqual(readonlyStart) || focus.isEqual(readonlyEnd))) {
                        writer.removeAttribute('readonly', writer.createRange(readonlyStart, readonlyEnd));
                    }
                }
            } else {
                for (const range of ranges) {
                    if (valueToSet) {
                        // writer.setAttribute( 'readonly', valueToSet, range );
                        const readonly = writer.createElement('readonly', {
                            ...Object.fromEntries(selection.getAttributes()),
                            content
                        });
                        model.insertContent(readonly);
                        writer.setSelection(readonly, 'after');
                    } else {
                        // writer.removeAttribute( 'readonly', range );
                        const element = selection.getSelectedElement();
                        if (element) {
                            const text = element.getAttribute('content');
                            writer.insertText(text, element, 'before');
                            model.deleteContent(selection);
                        }
                    }
                }
            }
        });
    }
}
